import { Header } from "antd/es/layout/layout";

const SectionHeader = ({ label }) => (
    <Header style={{
        background: '#131313',
        color: '#909090',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0.25px',
        textTransform: 'uppercase',
    }}>
        {label}
    </Header>
);

export default SectionHeader;
